import { visualizacao3dDoItem } from "./visualizacao3d";

// Preço, custo e filamento do catálogo são unitários; tempo e extras pertencem ao lote.
// O orçamento recebe uma cópia desses valores para manter o preço combinado.
export function itemDoCatalogo(produto, quantidade, preco) {
  const qtd = Number(quantidade), valor = Number(preco);
  if (!produto?.id || !produto.nome?.trim()) throw new Error("Selecione um produto.");
  if (!Number.isSafeInteger(qtd) || qtd < 1) throw new Error("Informe uma quantidade inteira maior que zero.");
  if (String(preco).trim() === "" || !Number.isFinite(valor) || valor < 0 || !Number.isSafeInteger(Math.round(valor * qtd * 100))) throw new Error("Informe um preço válido.");
  const lote = Math.max(1, Number(produto.unidades) || 1);
  const porUnidade = valor => valor == null ? null : (Number(valor) || 0) / lote;
  const fotos = (produto.fotos || []).filter(f => f.tipo !== "video").map(f => typeof f === "string" ? f : f.url).filter(Boolean);
  if (!fotos.length && produto.fotoBase64) fotos.push(produto.fotoBase64);
  const visualizacao3d = visualizacao3dDoItem(produto);
  const arquivo = visualizacao3d && (produto.arquivos || []).find(a => a.url === visualizacao3d.url);
  return {
    ...(visualizacao3d ? { visualizacao3d } : {}),
    ...(arquivo ? { arquivo: { ...arquivo, placasSelecionadas: [...visualizacao3d.placas], compartilhado: true } } : {}),
    produto_id: produto.id, nome: produto.nome.trim(), quantidade: qtd,
    preco: Math.round(valor * 100) / 100,
    custo_total: Number(produto.custo_total) || 0,
    fotos, altura: produto.altura ?? null, observacoes: "", cores: produto.cores || [],
    unidades: 1, horas_impressao: porUnidade(produto.horas_impressao),
    impressora_id: produto.impressora_id || null,
    mao_obra_hrs: porUnidade(produto.mao_obra_hrs), mao_obra_valor_hr: produto.mao_obra_valor_hr ?? null,
    filamentos_usados: (produto.filamentos_usados || []).map(f => ({ ...f })),
    materiais_usados: (produto.materiais_usados || []).map(m => ({ ...m, qtd: porUnidade(m.qtd) })),
    custos_adicionais: (produto.custos_adicionais || []).map(c => c.tipo === "percentual" ? { ...c }
      : c.tipo === "por_unidade" ? { ...c, quantidade: porUnidade(c.quantidade ?? 1) }
      : { ...c, valor: porUnidade(c.valor) }),
    taxas_usadas: (produto.taxas_usadas || []).map(t => ({ ...t })),
  };
}